<p class="date-time-label">{{ dateTime | date: 'MMM d, y, h:mm a' }}</p>
